import type { PackageSlug } from "./Packages"

/** A documented package's name: "tfunc" is "@pdfking/tfunc". */
export const PackageName = (slug: PackageSlug) => `@pdfking/${slug}` as const
